import { OrderDocumentStatus, _getOrderStatusUrl } from '../constants';

export const getOrderStatus = async (
    orderId: string,
    env: 'dev' | 'qa' | 'prod',
): Promise<OrderDocumentStatus> => {
    const response = await fetch(_getOrderStatusUrl(orderId, env), {
        method: 'GET',
        credentials: 'include',
    });

    const body = await response.json();

    if (body.error) {
        throw new Error(body.error);
    }

    return body.status;
};
